export enum Pages {
    LOGIN = 1,
    SECURITY_QUESTIONS_1 = 2,
    SECURITY_QUESTIONS_2 = 3,
    CONTACTS = 4,
    ORIGIN_MAP = 5,
    ORIGIN_MAP_VALIDATION = 6,
    ISSUE_DETAILS = 7,
    TIRES = 8,
    DESTINATION_MAP = 9,
    DESTINATION_MAP_VALIDATION = 10,
    SERVICE_DETAILS = 11,
    DIMENSION_PICKUP = 12,
    DIMENSION_VEHICLE = 13,
    SUMMARY = 14,
    SERVICE_SUCCESS = 15,
    TAKEN_SERVICE = 16
}
